import Vue from 'vue'
import store from './store'
import moment from 'moment'

import 'moment/locale/el'
import 'moment/locale/en-gb'

moment.locale(store.getters['language/selectedId']);
Vue.prototype.moment = window.moment = moment;